import PhilosophyScene from '@/glxp/scenes/philosophyScene'
import PartnersScene from '@/glxp/scenes/partnersScene'
import HomeGLScene from '@/glxp/scenes/homeScene'

class Manager {
  constructor () {
    this.scenes = {}
    this.initialized = false
    this.mobile = false
  }

  init (container) {
    this.mobile = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)
    window.innerWidth < 2000 ? this.dpr = Math.min(window.devicePixelRatio, 2) : this.dpr = Math.min(window.devicePixelRatio, 1)
    this.width = container.offsetWidth * this.dpr
    this.height = container.offsetHeight * this.dpr
    this.container = container
    this.catchContext()
    this.initialized = true
    this.mobile = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)
    
    this.initScenes()


    window.addEventListener('resize', () => {
      this.resize()
    })

    return this
  }

  initScenes () {
    this.addScene('philosophy', PhilosophyScene)
    this.addScene('partners', PartnersScene)
    if (!this.mobile) {
      this.addScene('home', HomeGLScene)
    }
  }

  addScene (id, scene) {
    this.scenes[id] = {
      scene: new scene(this.container, this),
      active: false,
      callbackCanvas: null
    }
  }

  registerCallbackCanvas (id, canvas) {
    this.scenes[id].callbackCanvas = canvas
  }

  getScene (id) {
    return this.scenes[id].scene
  }

  loadScene (id) {
    if (this.scenes[id].scene.loaded == false) {
      this.scenes[id].scene.load()
      this.scenes[id].scene.on('loaded', () => {
        this.scenes[id].scene.onResize()
        setTimeout(() => {
          this.recomputeBounds()
        }, 300)
      })
    }
  }

  activate (id) {
    this.setStyle({
      visibility: 'visible'
    })
    this.scenes[id].active = true
  }

  recomputeBounds () {
    for (const scene in this.scenes) {
      if (this.scenes.hasOwnProperty(scene)) {
        const sc = this.scenes[scene]
        sc.scene.resize()
        for (let i = 0; i < sc.scene.passes.length; i++) {
          const rt = sc.scene.passes[i]
          rt.onResize()
        }
      }
    }
    this.resize()
  }

  setHeight (height) {
    this.container.style.height = height + 'px'
    this.resize()
  }

  resize () {
    this.width = this.container.offsetWidth * this.dpr
    this.height = this.container.offsetHeight * this.dpr
    this.canvas.width = this.width
    this.canvas.height = this.height
    this.canvas.style.maxWidth = this.container.offsetWidth + 'px'
    this.canvas.style.maxHeight = this.container.offsetHeight + 'px'
    this.gl.viewport(0, 0, this.width, this.height)
  }

  setStyle (style) {
    for (const key in style) {
      if (style.hasOwnProperty(key)) {
        this.container.style[key] = style[key]
      }
    }
  }

  desactivate (id) {
    this.scenes[id].active = false
    this.setHeight(window.innerHeight)
    this.setStyle({
      zIndex: 0,
      pointerEvents: 'none',
      visibility: 'hidden',
      opacity: 1
    })
    this.gl.clearColor(0, 0, 0, 0)
    this.gl.clear(this.COLOR_BUFFER_BIT | this.DEPTH_BUFFER_BIT)
    this.gl.colorMask(true, true, true, true)
  }

  catchContext () {
    this.canvas = document.createElement('canvas')
    this.canvas.width = this.width
    this.canvas.height = this.height
    this.canvas.style.maxWidth = this.container.offsetWidth + 'px'
    this.canvas.style.maxHeight = this.container.offsetHeight + 'px'
    this.container.appendChild(this.canvas)

    this.gl = this.canvas.getContext('webgl', {
      antialias: false
    })
    if (this.gl == undefined) { return }

    // enable extensions

    // VAO Polyfill
    let vaoExt = this.gl.getExtension('OES_vertex_array_object')
    if (vaoExt) {
      this.gl['createVertexArray'] = function () { return vaoExt['createVertexArrayOES']() }
      this.gl['deleteVertexArray'] = function (vao) { vaoExt['deleteVertexArrayOES'](vao) }
      this.gl['bindVertexArray'] = function (vao) { vaoExt['bindVertexArrayOES'](vao) }
      this.gl['isVertexArray'] = function (vao) { return vaoExt['isVertexArrayOES'](vao) }
    }
    this.gl.getExtension('OES_standard_derivatives')
    this.gl.getExtension('EXT_shader_texture_lod')

    this.gl.getExtension('OES_texture_float')
    this.gl.getExtension('OES_texture_float_linear')
  }

  render () {
    for (const scene in this.scenes) {
      if (this.scenes.hasOwnProperty(scene)) {
        const sc = this.scenes[scene]
        if (sc.active == true) {
          sc.scene.render()
        }
      }
    }
  }
}

const out = new Manager()
export default out